import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { I18N } from 'commons';

const alertInfoWin = ({
  isOpen, title, handleConfirm, content, ebTestValue
}) => (
  <Modal
    isOpen={isOpen}
    className="verify-location new"
    aria-labelledby="subAlertDescription"
    aria-describedby="subAlertDescription"
  >
    <ModalHeader>
      <I18N id="subAlertDescription">{title}</I18N>
    </ModalHeader>
    <ModalBody className="delete-confirm-modal" tabIndex="0">
      <I18N>{content}</I18N>
    </ModalBody>
    <ModalFooter>
      <Button color="primary" eb-test={ebTestValue} onClick={() => { handleConfirm(false); }}>
        <I18N>global.dialog.button.ok</I18N>
      </Button>
    </ModalFooter>
  </Modal>
);


alertInfoWin.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  ebTestValue: PropTypes.string.isRequired,

};

export default alertInfoWin;
